import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAccessToken } from "../../use-access-token";
import { configuration } from "../../../configuration";
import { FetchError } from "../../types";
import { queryKeys } from "../queryKeys";

type Variables = {
  slug: string;
  modifiedByUserId: string;
};

const useDeleteTeamVideoRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function deleteTeamVideoRequest(variables: Variables) {
    const accessToken = await getAccessToken();

    const response = await fetch(`${configuration.apiRootUrl}/teams/${variables.slug}/video`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: "delete",
    });

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { deleteTeamVideoRequest };
};

const useDeleteTeamVideo = () => {
  const { deleteTeamVideoRequest } = useDeleteTeamVideoRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteTeamVideoRequest,
    onSuccess: (_data, variables) => {
      queryClient.refetchQueries(queryKeys.teams.getTeam(variables.slug, variables.modifiedByUserId));
    },
  });
};

export { useDeleteTeamVideo };
